import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const MessageCreatedAuditItemDetails = ({ audit }) => {
  const { auditedChanges, conversation } = audit
  const { text } = auditedChanges
  const { title } = conversation

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> added a message to <span className="font-semibold">{title}</span>:
      </span>
      <div className="mt-4">
        { text }
      </div>
    </div>
  )
}

MessageCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default MessageCreatedAuditItemDetails
